import { Injectable } from '@angular/core';
import { CLOUDINARY_PICTURE_UPDATE } from '@core/state/action-types';
import { IAppState } from '@core/state/app/app-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { UpdateCloudinaryAvatarAction } from '../actions/cloudinary-actions';
import { concatMap, from, map } from 'rxjs';
import { CloudinaryImageUpdateRequest } from '@core/data/api/cloudinary/cloudinary-image-update-request';
import { ImageService } from '@core/services/image.service';
import { FileItem } from 'ng2-file-upload';
import { NoAction } from '../actions/no-action';
import { ossCatchError } from '@core/operators/catch-error.operator';

@Injectable()
export class CloudinaryEffects {

    constructor(private actions$: Actions,
                private store$: Store<IAppState>,
                private imageService: ImageService) {}

    updateCloudinaryImage$ = createEffect(() =>
        this.actions$.pipe(
            ofType<UpdateCloudinaryAvatarAction>(CLOUDINARY_PICTURE_UPDATE),
            concatMap((action: UpdateCloudinaryAvatarAction) => {
                const uploader = action.payload.request.uploader;

                const targetId: string = action.payload.targetId;
                const request: CloudinaryImageUpdateRequest = action.payload.request;

                return this.imageService
                            .getSignature(targetId, request.cloudinaryImageType, [
                                request.cloudinaryImageProfile,
                                request.cloudinaryImageType,
                            ])
                            .pipe(
                                map((value: any) => {
                                    const fileToUpload: FileItem =
                                        request.uploader.queue[
                                            request.uploader.queue.length - 1
                                        ];

                                    fileToUpload.withCredentials = false;

                                    uploader.setOptions({
                                        url: value.base_api_url,
                                        additionalParameter: {
                                            api_key: value.api_key,
                                            tags: value.tags,
                                            signature: value.signature,
                                            timestamp: value.timestamp,
                                            public_id: value.public_id,
                                        },
                                    });

                                    uploader.uploadItem(fileToUpload);

                                    uploader.onCompleteItem = (
                                        fileItem: any,
                                        response: string
                                    ) => {
                                        this.store$.dispatch((action as any).success({
                                            ...JSON.parse(response),
                                            ...value
                                        }));

                                        uploader.cancelAll();
                                    };

                                    uploader.onErrorItem = (
                                        fileItem: any,
                                        response: string
                                    ) => {
                                        this.store$.dispatch((action as any).error(response));
                                        uploader.cancelAll();
                                    };

                                    uploader.onCancelItem = (
                                        fileItem: any,
                                        response: string
                                    ) => {
                                        this.store$.dispatch((action as any).error(response));
                                        uploader.cancelAll();
                                    };

                                    return new NoAction();
                                }),
                                ossCatchError(([actions, error]) =>
                                    from(actions.concat([(action as any).error(error)]))
                                )
                            );
            })
        )
    );

}
